ko.validation.rules['addressTitle1Validation'] = {
    validator: function (value, options) {
        return !_.getOptionOrDefault(value, 'Disabled', false);
    },
    message: ""
};
ko.validation.rules['addressContactValidation'] = {
    validator: function (value, options) {
        var numberRegex = new RegExp("(\\+|0)+[0-9\- ]{4,15}");
        options = _.getOptionOrDefault(options, 'params', {});
        var propName = _.getOptionOrDefault(options, 'propName', "");
        var address = _.getOptionOrDefault(options, 'address', null);
        if (_.isNull(address))
            return true;
        var onlyIf = _.getOptionOrDefault(options, 'onlyIf', function () { return true; });
        if (_.isFunction(onlyIf) && !onlyIf())
            return true;
        var addressPrefix = _.getOptionOrDefault(options, 'addressPrefix', "");
        if (addressPrefix.length > 0)
            addressPrefix += ' ';

        // check for 
        var msg = "";
        var mobile = address.mobileNumber();

        var number = address.phoneNumber();
        var prefix = address.phonePrefix();
        if (_.isEmpty(number) && _.isEmpty(prefix)) {
            if (_.isEmpty(mobile)) {
                msg = "Bitte geben Sie eine Festnetz oder Mobilfunknumber ein.";
            }
        } else {
            if (_.isEmpty(number)) {
                msg = "Bitte geben Sie eine Festnetznummer ein.";
            }
            else if (_.isEmpty(prefix)) {
                msg = "Bitte geben Sie die Festnetzvorwahl ein.";
            }
        }

        if (!_.isEmpty(mobile) && propName === 'mobileNumber') {
            if (!numberRegex.test(mobile)) {
                msg = "Die eingegebene Handynummer ist ungültig.";
            }
        }
        if ((!_.isEmpty(prefix) && !_.isEmpty(number)) &&
            (propName === 'phoneNumber' || propName === 'phonePrefix')) {
            var wholeNumber = prefix.concat(number);
            if (!numberRegex.test(wholeNumber)) {
                msg = "Die eingegebene Telefonnummer ist ungültig.";
            }
        }
        this.message = addressPrefix + msg;
        return _.isEmpty(msg);
    },
    message: ""
};
ko.validation.rules['addressCountryValidation'] = {
    validator: function (value, options) {

        var current = _.getOptionOrDefault(options, 'address', "");

        return current.isDeliveryAddress() && current.useInvoiceAddress() ? current.country().selectedItem().Id === current.invoiceAddress.country().selectedItem().Id : true;
    },
    message: ""
};
ko.validation.registerExtenders();

export class BaseAddressViewModel {
    constructor(parent, options) {
        BaseViewModel.call(this);

        var self = this;
        self.parent = parent;
        self.options = options;
        self.isLoading = ko.observable(false);
        self.suggestedCities = ko.observableArray([]);
        self.showInstallmentHint = _.getOptionOrDefault(options, 'showInstallmentHint', ko.observable(false));
        self.allowInvoiceAddress = _.getOptionOrDefault(options, 'allowInvoiceAddress', ko.observable(true));
        self.mobileEnabled = ko.observable(false);
        self.serialize = function () {

            var obj = self.toJS();
            if (_.isString(obj.deliveryAmount)) {
                try {
                    obj.deliveryAmount = app.globalization.number.parseFloat(obj.deliveryAmount);
                } catch (exc) {
                    obj.deliveryAmount = null;
                }
            }
            if (self.isDeliveryAddress() && self.useInvoiceAddress()) {
                obj.invoiceAddress = self.invoiceAddress.serialize();
            }
            obj.title1Id = self.title1().selectedItem().Id;
            obj.title2Id = self.title2.selectedItem().Id;
            obj.countryId = self.country().selectedItem().Id;

            return obj;
        };
        self.suggestedCityClicked = function (cityName) {
            self.suggestedCities([]);
            self.city(cityName);
        };
        self.enableMobile = function () {
            self.mobileEnabled(true);
        };

        self.init = function () {

            self.id = ko.observable(_.getOptionOrDefault(options, 'id', -1));
            var countryList = _.tryDeepCopy(self.parent.countryList());
            var title1List = _.tryDeepCopy(self.parent.title1List());
            title1List.splice(0, 0, { "Id": 0, "Name": "", "Weight": -1, "Disabled": true });

            var title2List = _.tryDeepCopy(self.parent.title2List());
            var currentCountry = _.find(countryList,
                function (item) {
                    if (item.Id === _.getOptionOrDefault(options, 'countryId', app.globalization.config.countryId)) {
                        return item;
                    }
                });
            var currentTitle1 = _.find(title1List,
                function (item) {
                    if (item.Id === _.getOptionOrDefault(options, 'title1Id', 0)) {
                        return item;
                    }
                });
            var currentTitle2 = _.find(title2List,
                function (item) {
                    if (item.Id === _.getOptionOrDefault(options, 'title2Id', 1)) {
                        return item;
                    }
                });


            self.country = ko.observable(new SelectListViewModel(self,
                {
                    textKey: 'Name',
                    list: countryList,
                    selected: currentCountry,
                    defaultSelectFirst: true
                }));

            self.showVatIdentNumber = ko.pureComputed(function () {

                return self.commercial() &&
                    (self.country().selectedItem().Id === 2 || self.country().selectedItem().Id === 3);
            });
            self.vatIdentNumberPrefix = ko.pureComputed(function () {

                if (self.country().selectedItem().Id === 2)
                    return "U";
                if (self.country().selectedItem().Id === 3)
                    return "CHE";

                return "DE";
            });
            self.zipCodeRegex = ko.computed(function () {
                return self.country().selectedItem().ZipRegex;
            });
            self.title1 = ko.observable(new SelectListViewModel(self,
                {
                    textKey: 'Name',
                    list: title1List,
                    selected: currentTitle1,
                    defaultSelectFirst: true
                }));

            self.title2 = new SelectListViewModel(self,
                {
                    textKey: 'Name',
                    list: title2List,
                    selected: currentTitle2,
                    defaultSelectFirst: true
                });

            self.isDeliveryAddress = ko.observable(_.getOptionOrDefault(options, 'IsDeliveryAddress', true));
            self.commercial = ko.observable(_.getOptionOrDefault(options, 'commercial', false));
            self.supportCountrySelected = false;
            if (self.isDeliveryAddress()) {
                self.supportCountrySelected = !_.getOptionOrDefault(options, 'isOrder', false);
                self.useInvoiceAddress = ko.observable(_.getOptionOrDefault(options, 'useInvoiceAddress', false));
                self.useInvoiceAddress.subscribe(function () {
                    _.delay(function () { M.updateTextFields(); }, 50);
                });

                var invoiceAddress = _.getOptionOrDefault(options, 'invoiceAddress', {});
                self.invoiceAddress = new BaseAddressViewModel(parent,
                    _.extend(invoiceAddress, { IsDeliveryAddress: false, DeliveryAddress: self }));
            } else {
                self.supportCountrySelected = true;
                self.deliveryAddress = _.getOptionOrDefault(options, 'DeliveryAddress', {});
            }

            self.mail = ko.observable(_.getOptionOrDefault(options, 'mail', ''));

            self.companyName = ko.observable(_.getOptionOrDefault(options, 'companyName', ''));
            self.companyName2 = ko.observable(_.getOptionOrDefault(options, 'companyName2', ''));

            self.firstName = ko.observable(_.getOptionOrDefault(options, 'firstName', ''));
            self.lastName = ko.observable(_.getOptionOrDefault(options, 'lastName', ''));

            self.streetName = ko.observable(_.getOptionOrDefault(options, 'streetName', ''));
            self.streetNumber = ko.observable(_.getOptionOrDefault(options, 'streetNumber', ''));

            self.zipCode = ko.observable(_.getOptionOrDefault(options, 'zipCode', ''));

            var searchCity = _.debounce(function (zip) { self._searchCity(zip); }, 200);
            self.zipCode.subscribe((zip) => {
                searchCity(zip);
            });

            self.city = ko.observable(_.getOptionOrDefault(options, 'city', ''));
            self.city.subscribe(() => {
                self.suggestedCities([]);
            });
            self.phoneRequired = ko.computed(function () {
                return app.orderType !== "Shop";
            });
            self.phonePrefix = ko.observable(_.getOptionOrDefault(options, 'phonePrefix', ''));
            self.phoneNumber = ko.observable(_.getOptionOrDefault(options, 'phoneNumber', ''));
            self.mobileNumber = ko.observable(_.getOptionOrDefault(options, 'mobileNumber', ''));
            self.countryId = ko.observable(_.getOptionOrDefault(options, 'countryId', app.globalization.config.countryId));
            self.vatIdentNumber = ko.observable(_.getOptionOrDefault(options, 'vatIdentNumber', ''));

            self.mobileEnabled(!_.isEmpty(self.mobileNumber()));


            /*
             *
             * initialize validation
             */
            var prefix = "Lieferadresse: ";
            if (!self.isDeliveryAddress())
                prefix = "Rechnungsadresse: ";

            self.companyName.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie einen Firmennamen.",
                    onlyIf: ko.computed(function () {
                        return (self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress()) && self.commercial();
                    })
                }
            });

            self.title1().selectedItem.extend({
                addressTitle1Validation: {
                    validator: function () { return !self.title1().selectedItem.Disabled },
                    message: prefix + 'Bitte wählen Sie eine Anrede aus.',
                    params: {
                        address: self,
                        onlyIf: ko.computed(function () { return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress(); })
                    }
                }
            });
            self.firstName.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie einen Vornamen.",
                    onlyIf: ko.computed(function () {
                        return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress();
                    })
                }
            });
            self.lastName.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie einen Nachnamen.",
                    onlyIf: ko.computed(function () {
                        return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress();
                    })
                }
            });
            self.streetName.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie eine Straße.",
                    onlyIf: ko.computed(function () {
                        return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress();
                    })
                }
            });
            self.mail.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie eine E-Mail Adresse.",
                    onlyIf: ko.computed(function () {
                        return self.options.validateMail && (self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress());
                    })
                }
            });
            self.streetNumber.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie eine Hausnummer.",
                    onlyIf: ko.computed(function () {
                        return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress();
                    })
                }
            });

            self.zipCode.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie eine Postleitzahl.",
                    onlyIf: ko.computed(function () {
                        return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress();
                    })
                },
                pattern: {
                    params: self.zipCodeRegex,
                    message: function () {
                        return "Die eingegebene Postleitzahl ist für " + self.country().selectedText() + " ungültig."
                    }
                }
            });
            self.city.extend({
                required: {
                    message: prefix + "Bitte hinterlegen Sie eine Stadt.",
                    onlyIf: ko.computed(function () {
                        return self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress();
                    })
                }
            });

            var isValidCountry = function (val) {
                return self.isDeliveryAddress() && self.useInvoiceAddress()
                    ? self.country().selectedItem().Id === self.invoiceAddress.country().selectedItem().Id
                    : true;
            };

            self.country().selectedItem.extend(
                {
                    addressCountryValidation: {
                        validator: isValidCountry,
                        message: 'Bitte wählen Sie für die abweichende Rechnungsadresse das selbe Land wie für die Lieferadresse',
                        params: {
                            address: self,
                            onlyIf: ko.computed(function () { return self.isDeliveryAddress() && app.orderType !== "Shop"; })
                        }
                    }
                });

            self.phonePrefix.extend({
                addressContactValidation: {
                    params: {
                        propName: "phonePrefix",
                        address: self,
                        onlyIf: ko.computed(function () { return (self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress()) && app.orderType !== "Shop"; }),
                        addressPrefix: prefix
                    }
                },
                maxLength: {
                    message: 'Die Vorwahl darf nicht mehr als 10 Zeichen enthalten.',
                    params: 10
                }
            });
            self.phoneNumber.extend({
                addressContactValidation: {
                    params: {
                        propName: "phoneNumber",
                        address: self,
                        onlyIf: ko.computed(function () { return (self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress()) && app.orderType !== "Shop"; }),
                        addressPrefix: prefix
                    },
                },
                maxLength: {
                    message: 'Die Telefonnummer darf nicht mehr als 16 Zeichen enthalten.',
                    params: 16
                }
            });
            self.mobileNumber.extend({
                addressContactValidation: {
                    params: {
                        propName: "mobileNumber",
                        address: self,
                        onlyIf: ko.computed(function () { return (self.isDeliveryAddress() || self.deliveryAddress.useInvoiceAddress()) && app.orderType !== "Shop"; }),
                        addressPrefix: prefix
                    }
                },
                maxLength: {
                    message: 'Die Mobilnummer darf nicht mehr als 22 Zeichen enthalten.',
                    params: 22
                }
            });

            self.errorGroup = ko.validation.group([self.mail, self.country().selectedItem, self.title1().selectedItem, self.companyName, self.firstName, self.lastName, self.streetName, self.streetNumber, self.city, self.zipCode, self.phonePrefix, self.phoneNumber, self.mobileNumber]);


            self.errors = ko.computed(function () {
                var messages = _.uniq(self.errorGroup());
                return messages;
            });
            self.visibleErrors = ko.computed(function () {
                var errors = [];
                self.errorGroup.forEach(function (observable) {
                    if (ko.validation.utils.isValidatable(observable) && !observable.isValid() && observable.isModified()) {
                        errors.push(observable.error.peek());
                    }
                });
                if (self.isDeliveryAddress() && self.useInvoiceAddress()) {
                    var invoiceErrors = self.invoiceAddress.visibleErrors();
                    _.each(invoiceErrors, function (ie) {
                        errors.push(ie);
                    });
                }
                return _.uniq(errors);
            });
            self.hasErrors = ko.computed(function () {
                return self.visibleErrors().length > 0;
            });
            self.validate = function () {

                var msg = self.errors();
                self.errorGroup.showAllMessages();
                var valid = msg.length === 0;
                if (self.isDeliveryAddress() && self.useInvoiceAddress()) {
                    valid &= self.invoiceAddress.validate();
                }
                ko.setErrorIf(self.title1, !self.title1().isValid(), "Bitte wählen Sie eine Anrede aus.", function () {
                    valid = false;
                });

                return valid;
            };
            self.errorGroup.showAllMessages(false);
        };

        $(document).ready(function () {
            $('*').click(function (event) {
                self.suggestedCities([]);
            });
            $('*').focus(function (event) {
                self.suggestedCities([]);
            });
        });

        self.toHash = function () {
            return self.serialize();
        };


        self._searchCity = function (zip) {
            self.suggestedCities([]);

            var countryId = self.country().selectedItem().Id;
            
            if (!zip || (countryId === 1 && zip.length !== 5) || (countryId === 2 && zip.length !== 4) || (countryId === 3 && zip.length !== 4))
                return;

            $.get('/api/location/getMatchingCities/' + zip + "/" + countryId).
                done(function (result) {

                    if (result.success) {
                        if (result.Cities && result.Cities.length > 0) {

                            _.each(result.Cities, function (element) {
                                self.suggestedCities.push(element);
                            });
                        }
                    }

                })
                .fail(function () {
                    console.log("Städte konnten nicht abgerufen werden");
                    //M.toast({ html: 'Beim Abrufen der Supporter-Daten ist etwas schiefgelaufen.', classes: 'red', displayLength: 30000 });
                })
                .always(function () {
                    //self.isRefreshing(false);
                });
        }


        self.init();

        self.ignore.push('errorGroup');
        self.ignore.push('errors');
        self.ignore.push('hasErrors');
        self.ignore.push('validate');

        self.ignore.push('deliveryAddress');


        self.ignore.push('title1');
        self.ignore.push('title2');
        self.ignore.push('addressBook');
        self.ignore.push('next');
        self.ignore.push('previous');
        self.ignore.push('options');
        self.ignore.push('invoiceAddress');
    }

};
ExtendViewModel(BaseAddressViewModel, BaseViewModel);